<template>
  <div>
    <epi-offcanvas :opening-event-name="openingEventName" title="고객 정보">
      <template v-slot:body> </template>
    </epi-offcanvas>
  </div>
</template>

<script>
import { EventName } from "@/const";

export default {
  name: "CustomerDetailOffcanvas",
  data() {
    return {
      openingEventName: EventName.CustomerDetailOffcanvasOpening,
    };
  },
};
</script>
